import { NgModule } from "@angular/core";
import { WalletsFacade } from "@modules/+new/wallets/domain/+state/wallets.facade";
import { WalletsBridgeService } from "@modules/+new/wallets/domain/+state/wallets-bridge.service";
import { FiatWalletAdapter } from "@modules/+new/wallets/domain/entities/fiat-wallet.model";
import { CryptoCoinWalletAdapter } from "@modules/+new/wallets/domain/entities/cryptocoin-wallet.model";
import { TradableBaseWalletAdapter } from "@modules/+new/wallets/domain/entities/abstract/tradable-wallet-base.model";
import { AssetWalletAddressAdapter } from "@modules/+new/wallets/domain/entities/asset-wallet-address.model";
import { AssetWalletBaseAdapter } from "@modules/+new/wallets/domain/entities/abstract/asset-wallet-base-model";

@NgModule({
	providers: [
		WalletsFacade,
		WalletsBridgeService,
		FiatWalletAdapter,
		TradableBaseWalletAdapter,
		CryptoCoinWalletAdapter,
		AssetWalletAddressAdapter,
		AssetWalletBaseAdapter
	]
})
export class WalletsModule {}
